import { takeLatest, call, select, put } from "redux-saga/effects";
import log from "loglevel"

import getEnvParam from "../../utils/getEnvParam";
import { saveAs } from "file-saver";
import { requestDefaultJson } from './helpers'

const schedulingFromApi = (idCarga, idPortao, dtEntrega, horaEntrega, token, idAgendamento = '') => {
	return requestDefaultJson({
		method: "POST",
		URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") + '/agendamento/salvarAgendamento/' + idAgendamento,
		headers: {
			"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_AGENDAMENTO"),
			"Authorization": token
		},
		data: {
			idCarga: idCarga,
			idPortao: idPortao,
			dtEntrega: dtEntrega,
			horaEntrega: horaEntrega,
		}
	});
};

const schedulingCancelFromApi = ( token, idCarga, idAgendamento) => {
	
	return requestDefaultJson({
		method: "DELETE",
		URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") + '/agendamento/cancelarAgendamento/',
		headers: {
			"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_AGENDAMENTO"),
			"Authorization": token
		},
		data: {
			idCarga: idCarga,
			idAgendamento: idAgendamento
		}
	});
};

const getCompanyId = (permission) => {
	let companyName = permission.split('_')
	companyName = companyName[1]

	if (companyName === 'Renner') {
		return '001'
	}

	if (companyName === 'Camicado') {
		return '003'
	}

	if (companyName === 'Youcom') {
		return '004'
	}
}

const addFilter = (filter, filterName) => {
	if (filter) {
		return '&' + filterName + '=' + filter
	} else {
		return ''
	}
}

const schedulingReportFromApi = ( token, payload) => {
	let {idEmpresa} = payload.filters

	const {
		nomeFornecedor,
		nomePortao,
		dtEntregaIni,
		dtEntregaFim
	 } = payload.filters

	idEmpresa = payload.checkPermission ? getCompanyId(payload.permissions[0]) : idEmpresa

	const urlFilters = 
		'idEmpresa=' + idEmpresa + 
		addFilter(nomeFornecedor, 'nomeFornecedor') +
		addFilter(nomePortao, 'nomePortao') +
		addFilter(dtEntregaIni, 'dtEntregaIni') +
		addFilter(dtEntregaFim, 'dtEntregaFim')
		
	return requestDefaultJson({
		method: "GET",
		URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") + '/relatorios/Reports/agendamento.pdf?' + urlFilters,
		headers: {
			"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_REPORT"),
			"Authorization": token
		},
		responseType: 'blob'
	});
};

const schedulingReportFromApiCSV = ( token, payload) => {
	let {idEmpresa} = payload.filters

	const {
		nomeFornecedor,
		nomePortao,
		dtEntregaIni,
		dtEntregaFim
	 } = payload.filters

	idEmpresa = payload.checkPermission ? getCompanyId(payload.permissions[0]) : idEmpresa

	const urlFilters = 
		'idEmpresa=' + idEmpresa + 
		addFilter(nomeFornecedor, 'nomeFornecedor') +
		addFilter(nomePortao, 'nomePortao') +
		addFilter(dtEntregaIni, 'dtEntregaIni') +
		addFilter(dtEntregaFim, 'dtEntregaFim')
		
	return requestDefaultJson({
		method: "GET",
		URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") + '/agendamento/relatorio?' + urlFilters,
		headers: {
			"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_AGENDAMENTO"),
			"Authorization": token
		},
	});
};

//generators
function* scheduling({payload}) {
	try {
		yield put({ type: "SCHEDULING_LOADING"});

		const { token } = yield select(state => state.authentication)

		yield call(schedulingFromApi, payload.idCarga, payload.idPortao, payload.dtEntrega, payload.horaEntrega, token);
		
		if(payload.idAgendamento){
			yield put({ type: "SCHEDULING_SUCCESS", payload:{ success: true, type: "update"}});
		} else {
			yield put({ type: "SCHEDULING_SUCCESS", payload:{ success: true, type: "save"}});
		}

	} catch (error) {

		yield put({ type: "SCHEDULING_ERROR", payload:{ error: true, data: error.response.data }});

		log.info(error);
	}
}

function* schedulingCancel({payload}) {
	try {
		yield put({ type: "SCHEDULING_LOADING"});

		const { token } = yield select(state => state.authentication)

		yield call(schedulingCancelFromApi, token,payload.idCarga,payload.idAgendamento);
		
		yield put({ type: "SCHEDULING_SUCCESS", payload:{ success: true, type: "delete"}});
	} catch (error) {
		yield put({ type: "SCHEDULING_ERROR", payload:{ error: true, data: error.response.data } });
		log.info(error);
	}
}

function* getSchedulingReport(payload) {
	try {
		yield put({ type: "SET_LOADING_SCHEDULING_REPORT", payload: true });

		const { token } = yield select(state => state.authentication)

		let data = yield call(schedulingReportFromApi, token, payload.payload);

		saveAs(data, `relatorio_agendamento.pdf`);
		
		yield put({ type: "SET_LOADING_SCHEDULING_REPORT", payload: false });
	} catch (error) {
		yield put({ type: "SET_LOADING_SCHEDULING_REPORT", payload: false });
		log.info(error);
	}
}

function* getCSVSchedulingReport(payload) {
	try {
		yield put({ type: "SET_LOADING_SCHEDULING_REPORT", payload: true });

		const { token } = yield select(state => state.authentication)

		let data = yield call(schedulingReportFromApiCSV, token, payload.payload);

		yield put({ type: "SET_CSV_SCHEDULING_REPORT", payload: data });
		
		yield put({ type: "SET_LOADING_SCHEDULING_REPORT", payload: false });
	} catch (error) {
		yield put({ type: "SET_LOADING_SCHEDULING_REPORT", payload: false });
		log.info(error);
	}
}

// //Generator function
export function* schedulingWatcher() {
	yield takeLatest("SAVE_SCHEDULING", scheduling);
	yield takeLatest("CANCEL_SCHEDULING", schedulingCancel);
	yield takeLatest("GET_SCHEDULING_REPORT", getSchedulingReport);
	yield takeLatest("GET_CSV_SCHEDULING_REPORT", getCSVSchedulingReport);
}
